import React from 'react';
import { Box } from '@mui/material';
import EmailIntegration from './EmailIntegration';
import EmailFormFields from './EmailFormFields';
import { IMAPSource, SMTPSource } from '../../models/email-service';

interface EmailTabProps {
  type: 'user' | 'tenant';
  form: {
    imapHost?: string | number;
    imapPort?: string | number;
    imapUsername?: string;
    imapPassword?: string | null;
    imapSource?: string | IMAPSource;
    smtpHost?: string;
    smtpPort?: string | number;
    smtpSecure?: boolean;
    smtpSource?: string | SMTPSource;
    workingEmailSignaturePlain?: string;
    workingEmailSignatureHtml?: string;
    workingEmail?: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeEmailSignaturePlain: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeEmailSignatureHtml: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLinkEmail: (mail: string) => Promise<void>;
  smtpSource?: SMTPSource;
  imapSource?: IMAPSource;
  emailAddress?: string;
  variant?: 'textfield' | 'textinput';
}

/**
 * Shared email configuration tab component.
 * Used by both ProfileDialog and tenantSettingsModal to provide email integration settings.
 * Similar to ScoringTab pattern - encapsulates the entire tab content.
 */
const EmailTab: React.FC<EmailTabProps> = ({
  type,
  form,
  onChange,
  onChangeEmailSignaturePlain,
  onChangeEmailSignatureHtml,
  onLinkEmail,
  smtpSource,
  imapSource,
  emailAddress,
  variant = 'textfield',
}) => (
  <Box>
    <EmailIntegration
      type={type}
      smtpSource={smtpSource}
      imapSource={imapSource}
      emailAddress={emailAddress}
      onLinkEmail={onLinkEmail}
      emailSignaturePlain={form.workingEmailSignaturePlain || ''}
      emailSignatureHtml={form.workingEmailSignatureHtml || ''}
      onChangeEmailSignaturePlain={onChangeEmailSignaturePlain}
      onChangeEmailSignatureHtml={onChangeEmailSignatureHtml}
    >
      <EmailFormFields form={form} onChange={onChange} variant={variant} />
    </EmailIntegration>
  </Box>
);

export default EmailTab;
